const { CardHeader, CardBody, CardFooter, Card, Col, Row, Button } = require("reactstrap");
import { useMutation } from '@apollo/client';
import { useAuth } from 'components/custom/authprovider';
import { GET_ACCESS_TOKEN } from 'graphql/mutations/plaid';
import { GET_LINK_TOKEN } from 'graphql/mutations/plaid';
import { useEffect, useState } from 'react';
import { PlaidLink } from 'react-plaid-link';
import { useHistory } from 'react-router-dom';
import useAutoLogout from 'utils/autoLogout';
import { SubDirectory } from 'utils/defaults';
import { APPCOOKIE } from 'utils/defaults';
import { usePackageId } from 'utils/functions';
import { SAText } from 'utils/functions';
import { getDeviceFingerprint } from 'utils/functions';


function LinkPlaid(){
  useAutoLogout();

  const [linkToken, setLinkToken] = useState();
  const {wt, setWT, setIsAuthenticated}  = useAuth();
  const history = useHistory();
  const packageId = usePackageId();

  const [generatePlaidLink] = useMutation(GET_LINK_TOKEN,{
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : '', // Include the token in the request header
        'X-Device-Fingerprint': getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        
        const serverError = errors.networkError.result.errors[0].message;
        if(serverError === "Authentication required."){
          history.push({pathname:"/logout"});
        }
      } 
    }
  });
  
  const [plaidGetAccessToken] = useMutation(GET_ACCESS_TOKEN,{
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : '', // Include the token in the request header
        'X-Device-Fingerprint': getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if(serverError === "Authentication required."){
          history.push({pathname:"/logout"});
        }
      } 
    }
  });

  useEffect(() => {
    generatePlaidLink()
    .then((res) => {
      console.log("RES", res);
      if(res.data.generatePlaidLink.status){
        setLinkToken(res.data.generatePlaidLink.data);
      }
      else{
        SAText("Error", res.data.generatePlaidLink.error, "error");
      }
    })
    .catch(() =>{
      SAText("Error", "Something Bad Happened", "error");
    });
  }, []);

  const PlaidSuccess = (public_token, meta_data) => {
    // Plaid Success public-sandbox-2686e669-4db9-4e8c-8a4f-159c62041aa3
    // console.log("Token", public_token)
    // console.log("MetaData", meta_data)

    const plaidData = {
      public_token: public_token,
      link_sessionid: meta_data.link_session_id,
      account_id: meta_data.account_id,
      institution_name: meta_data.institution.name,
      type: meta_data.account.subtype,
      the_four: meta_data.account.mask,
      account_name: meta_data.account.name
    };

    plaidGetAccessToken({variables: {plaidData} })
    .then((res) => {
      
      if(res.data.plaidGetAccessToken.status){
        //SET COOKIE AND AUTH
          const TheCookie ={
            wt: res.data.plaidGetAccessToken.token,
            dt: res.data.plaidGetAccessToken.dt,
            p: wt.p
          };
          const token = localStorage.setItem( APPCOOKIE, JSON.stringify(TheCookie) );

          setWT({ 
            wt: res.data.plaidGetAccessToken.token, 
            dt: res.data.plaidGetAccessToken.dt,
            p: wt.p
          });

          setIsAuthenticated({ token });

          
          history.push("/" + SubDirectory + "checkout/" + packageId);
      }
      else{
        SAText("Error", res.data.plaidGetAccessToken.error, "error");
      }
    })
    .catch((err) =>{
      console.log("Error",err);
      SAText("Error", "Something Bad Happened", "error");
    });
  };
  return (
    <div className="content">
    <Row>
        <Col md="12">
          <Card>
            <CardHeader className='subTitle'>Your accounts needs verified</CardHeader>
              <CardBody>
                In order to continue, you will need to link a bank account. No information about your bank will be stored. Your account will not be charged anything. This is only required to verify your identity. Your profile information must match the information on a bank account. 
                <br /><br />
                {linkToken && 
                <>
                  <PlaidLink
                    style={{background:"lime"}}
                      token={linkToken}
                      onSuccess={(public_token, metadata) => PlaidSuccess(public_token, metadata) }
                      // onEvent={...}
                      // onExit={...}
                    >
                      Continue Verification Process
                  </PlaidLink>

                  <br /><br />

                  <Button 
                    className="btn-fill " 
                    color="info" 
                    type="button" 
                    onClick = {() => {
                      history.push("/" + SubDirectory + "profile");
                    }}
                    >
                    Update Profile Information
                  </Button>
                </>
                }
              </CardBody>
            <CardFooter>
              
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default LinkPlaid;
